import React from "react";
import PropTypes from "prop-types";
import Tooltip from "../Tooltip";
import {useTranslation} from "react-i18next";
import {PRICE_TYPE_GROSS, PRICE_TYPE_NET} from "../../utils/price";
import {useShowPrice} from "../../contexts/ShowPriceContext";

function SelectPriceShow(props) {
  const { t } = useTranslation('select_price_show')
  const {showPrice, setShowPrice} = useShowPrice()
  const [keyId, setKeyId] = React.useState(btoa(Math.random()).substr(10, 5));
  const [value, setValue] = React.useState(props.value || showPrice);

  React.useEffect(() => {
    if (props.value !== undefined && props.value !== null) {
      setValue(props.value);
    } else {
      setValue(showPrice);
    }
  }, [props.value, showPrice]);

  return <React.Fragment>
    <div id={"price-switch" + keyId} className={`btn btn-${props.size} btn-light price-switch cursor-pointer`} onClick={() => {
      if(props.onChange) {
        props.onChange(value === PRICE_TYPE_GROSS ? PRICE_TYPE_NET : PRICE_TYPE_GROSS)
      }else {
        setShowPrice(value === PRICE_TYPE_GROSS ? PRICE_TYPE_NET : PRICE_TYPE_GROSS)
      }
    }}>{t(`common:${value}`)}</div>
    <Tooltip id={"price-switch" + keyId} msg={t('text', {value: t(`common:${value}`)})} />
  </React.Fragment>
};

SelectPriceShow.defaultProps = {
  size: 'sm',
};

SelectPriceShow.propTypes = {
  size: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default SelectPriceShow;